/* eslint-disable */
const celAppdynamics = () => {
  window['adrum-start-time'] = new Date().getTime();
  (function (config) {
    config.appKey = process.env.REACT_APP_APPDYNAMICS_APP_KEY_CEL;
    config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
    config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
    config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
    config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
    config.useHTTPSAlways = true;
    config.resTiming = { bufSize: 300, clearResTimingOnBeaconSend: true };
    config.xd = { enable: true };
    config.maxUrlLength = 2048;
    config.enableCoreWebVitals = true;
    config.spa = { spa2: { clearResTiming: true } };
    config.navComplete = {
      maxResourceQuietTime: 500,
      maxXhrQuietTime: 500,
      maxInactiveTime: 500,
    };
    function getCookieValue(cookieName) {
      try {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + cookieName + '=');
        if (parts.length == 2) {
          return parts.pop().split(';').shift();
        } else {
          return '';
        }
      } catch (err) {
        return 'error';
      }
    }
    config.userEventInfo = {
      PageView: function (context) {
        return {
          userDataDouble: {
            bookingAmount: parseFloat(getCookieValue('Persist_Room_Price')),
          },
          userData: {
            BlueGreenValue: getCookieValue('bgv'),
            MarketingCloudID: getCookieValue('MCMID'),
            LoyaltyID: getCookieValue('Persist_Loyalty_ID'),
            bookingCurrency: getCookieValue('Persist_Currency_Code'),
            destinationCode: getCookieValue('Persist_Dest_Code'),
            productName: getCookieValue('Persist_Product_Name'),
            bookingId: getCookieValue('bookingId'),
            sessionID: getCookieValue('sessionID'),
            authToken: getCookieValue('authToken'),
            videoTest: getCookieValue('ab-test-qa'),
            WUC: getCookieValue('wuc'),
            country: getCookieValue('country'),
            currency: getCookieValue('currencyCode'),
            autSession: getCookieValue('autsession'),
            AEM_Modernization: 'true',
          },
        };
      },
      Ajax: function (context) {
        return {
          userDataDouble: {
            bookingAmount: parseFloat(getCookieValue('Persist_Room_Price')),
          },
          userData: {
            BlueGreenValue: getCookieValue('bgv'),
            MarketingCloudID: getCookieValue('MCMID'),
            LoyaltyID: getCookieValue('Persist_Loyalty_ID'),
            bookingCurrency: getCookieValue('Persist_Currency_Code'),
            destinationCode: getCookieValue('Persist_Dest_Code'),
            productName: getCookieValue('Persist_Product_Name'),
            bookingId: getCookieValue('bookingId'),
            sessionID: getCookieValue('sessionID'),
            authToken: getCookieValue('authToken'),
            videoTest: getCookieValue('ab-test-qa'),
            WUC: getCookieValue('wuc'),
            country: getCookieValue('country'),
            currency: getCookieValue('currencyCode'),
            autSession: getCookieValue('autsession'),
            AEM_Modernization: 'true',
          },
        };
      },
      VPageView: function (context) {
        return {
          userDataDouble: {
            bookingAmount: parseFloat(getCookieValue('Persist_Room_Price')),
          },
          userData: {
            BlueGreenValue: getCookieValue('bgv'),
            MarketingCloudID: getCookieValue('MCMID'),
            LoyaltyID: getCookieValue('Persist_Loyalty_ID'),
            bookingCurrency: getCookieValue('Persist_Currency_Code'),
            destinationCode: getCookieValue('Persist_Dest_Code'),
            productName: getCookieValue('Persist_Product_Name'),
            bookingId: getCookieValue('bookingId'),
            sessionID: getCookieValue('sessionID'),
            authToken: getCookieValue('authToken'),
            videoTest: getCookieValue('ab-test-qa'),
            WUC: getCookieValue('wuc'),
            country: getCookieValue('country'),
            currency: getCookieValue('currencyCode'),
            autSession: getCookieValue('autsession'),
            AEM_Modernization: 'true',
          },
        };
      },
    };
  })(window['adrum-config'] || (window['adrum-config'] = {}));
};

export default celAppdynamics;
